import { render, staticRenderFns } from "./RsaConsensiListComponent.vue?vue&type=template&id=e56d6576"
import script from "./RsaConsensiListComponent.vue?vue&type=script&lang=js"
export * from "./RsaConsensiListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports